import Vue from "vue";
import Vuex from "vuex";
import hash from "object-hash";
import { ToastPlugin } from "bootstrap-vue";
import Translator from "@/services/translator";

Vue.use(ToastPlugin);
Vue.use(Vuex);

const mutationTypes = {
  ADD_FLASH: "ADD_FLASH",
  REMOVE_FLASH: "REMOVE_FLASH",
};

const store = new Vuex.Store({
  state: {
    ids: {},
    items: [],
  },
  mutations: {
    [mutationTypes.ADD_FLASH](state, data) {
      state.ids[data.id] = true;
      state.items.push(Object.assign({}, data));
    },
    [mutationTypes.REMOVE_FLASH](state, index) {
      const item = state.items[index];
      state.items.splice(index, 1);
      Vue.delete(state.ids, item.id);
    },
  },
});

const vm = new Vue({ store });

export const FLASH_ERROR = "error";
export const FLASH_SUCCESS = "success";
export const FLASH_INFO = "info";

const flashTypes = [FLASH_ERROR, FLASH_INFO, FLASH_SUCCESS];

function prepareConfig(config) {
  const defaultFlashConfig = {
    immediate: false,
    autoHide: false,
    delay: 5000,
    closeLabel: Translator.trans("flash.button.dismiss"),
  };

  return Object.assign({}, defaultFlashConfig, config);
}

function add(message, type = FLASH_INFO, config = {}) {
  if (!type) {
    type = FLASH_INFO;
  }

  if (flashTypes.indexOf(type) < 0) {
    throw new Error(`unknown flash type (${flashTypes.join("/")}): ${type}`);
  }

  config = prepareConfig(config);
  const item = { message, type, config };
  item.id = hash(item);

  if (config.immediate === true) {
    show(item);
    return;
  }

  store.commit(`${mutationTypes.ADD_FLASH}`, item);
}

function showAll() {
  const items = store.state.items;
  items.forEach((item, index) => {
    show(item);
    vm.$store.commit(`${mutationTypes.REMOVE_FLASH}`, index);
  });
}

function createMessageNode(message) {
  const h = vm.$createElement;
  return h("div", {
    class: ["toast-body-message"],
    domProps: { innerHTML: message },
  });
}

function createCloseButtonNode(item) {
  const h = vm.$createElement;

  return h(
    "button",
    {
      class: "btn close-btn",
      on: {
        click: () => hide(item),
      },
    },
    item.config.closeLabel
  );
}

function createActionsNode(item) {
  const h = vm.$createElement;
  return h("div", { class: ["toast-body-actions"] }, [
    createCloseButtonNode(item),
  ]);
}

function show(item) {
  const variants = {
    [FLASH_ERROR]: "danger",
    [FLASH_SUCCESS]: "success",
    [FLASH_INFO]: "info",
  };

  const variant = variants[item.type] || FLASH_INFO;

  vm.$bvToast.toast(
    [createMessageNode(item.message), createActionsNode(item)],
    {
      id: item.id,
      variant,
      title: item.config.title,
      solid: true,
      toaster: "b-toaster-top-center",
      noAutoHide: !item.config.autoHide,
      autoHideDelay: item.config.delay,
      noCloseButton: true,
    }
  );
}

function hide(item) {
  vm.$bvToast.hide(item.id);
}

function flash(message, type = FLASH_INFO, config = {}) {
  if (arguments.length === 0) {
    showAll();
    return;
  }

  add(message, type, config);
}

flash.error = function(message, config) {
  flash(message, FLASH_ERROR, config);
};

flash.success = function(message, config) {
  flash(message, FLASH_SUCCESS, config);
};

flash.info = function(message, config) {
  flash(message, FLASH_INFO, config);
};

export default flash;
